// import 'babel-polyfill'
import 'es5-shim'
import 'es5-shim/es5-sham'
import 'console-polyfill'

// import enLocale from './language/en-us.json'
// import zhLocale from './language/zh-cn.json'
// import '../node_modules/font-awesome/css/font-awesome.min.css'
// import Upload from './components/upload/index.js'
// import Upload from './components/upload/upload_vue/upload.vue'

import up from './components/upload/upload.js'

window.Upload = up

// const components = [
//   Upload
// ]

// const messages = {
//   en: enLocale,
//   zh: zhLocale
// }

// const install = function (Vue) {
//   if (install.installed) return
//
//   components.map(component => {
//     Vue.component(component.name, component)
//   })
// }

// if (typeof window !== 'undefined' && window.Vue) {
//   install(window.Vue)
//
//   // if (window.VueI18n) {
//   //   window.Vue.use(window.VueI18n)
//   //
//   //   window.i18n = new window.VueI18n({
//   //     locale: 'zh',
//   //     messages
//   //   })
//   // }
// }

export default {
  // install
  // messages
  up
}



// WEBPACK FOOTER //
// ./src/main.js